/**
 * How the two board surfaces render one attempt's figures.
 *
 * The table and the scatter plot show the same cohort in different shapes, so a
 * duration formatted one way in the rows and another in the axis labels would
 * read as two different measurements of the same sitting.
 */

/** The avatar fallback for a published name. "?" for a name that is all space. */
export function initial(name: string): string {
  return name.trim().charAt(0).toUpperCase() || "?";
}

/**
 * Whole minutes as a sitting length.
 *
 * Minutes below the hour, then hours with the remainder dropped when there is
 * none: a three-hour sitting reads "3h" rather than "3h 0m". Takes a number
 * rather than `number | null`, because "no duration was recorded" is a different
 * statement from a short one and only the table has a cell to put it in.
 */
export function durationLabel(minutes: number): string {
  if (minutes < 60) {
    return `${String(minutes)} min`;
  }
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  return rest === 0
    ? `${String(hours)}h`
    : `${String(hours)}h ${String(rest)}m`;
}
